import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbCreate: PageLink[] = [
  {
    title: 'Despesas',
    path: '/financial/expenses',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
